import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { addStructuredData } from '@/components/SEO';

/**
 * Hook to manage language-aware structured data for SEO
 * Automatically updates structured data when language changes
 */
export const useLanguageAwareSEO = (
  schemaGenerators: Array<(language: string) => object>
) => {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language || 'en';

  useEffect(() => {
    // Generate language-aware schemas
    const schemas = schemaGenerators.map(generator => generator(currentLanguage));
    
    // Add structured data
    const cleanup = addStructuredData({
      "@graph": schemas
    });
    
    return cleanup;
  }, [currentLanguage, schemaGenerators]);

  return currentLanguage;
};
